module.exports = __webpack_public_path__ + "static/img/gzz1.96a1d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzz1.png
// module id = sucA
// module chunks = 2